import { Component } from '@angular/core';
import { MessageService } from '../message/message.service';
@Component({
	selector: 'app-message',
	templateUrl: './message.component.html',
	styleUrls: ['./message.component.css'],
})
export class MessageComponent {
	message: object;

	constructor(public messageService: MessageService) {}
}
